<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="modal-header">
          <h4 class="modal-title"> Safe & Secure Payment </h4>
          <div *ngIf="userDetails.payment_completed" class="modal_close_btn"   (click)="close()">
            <span class="modal-close" ><i class="material-icons">close</i></span>
          </div>
        </div>
        <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
    

<div *ngIf="planDetails" style="    padding: 20px;     background: #ededed;
    border-radius: 10px;     margin-bottom: 20px;">
       <p  style="    font-weight: bold;    font-size: 18px; border-bottom: 1px solid #cbcbcbcc;
    padding-bottom: 15px;
    margin-bottom: 10px">{{ planDetails.name }}</p> 
    <div  style="display: flex; justify-content: space-between;"  >
  <p style="   font-size: 16px;"> Total Payable</p>
    <p  style="    font-weight: bold;    font-size: 16px;">  AUD  ${{planDetails.monthy_price }} </p>
 
  <!-- <p  style="    font-weight: bold;    font-size: 16px;">  AUD  ${{billingType === 'yearly' ? planDetails.yearly_price : planDetails.monthy_price }} 
  / {{ billingType }}</p> -->
  </div>
  
</div>
              <div class="online_payment_form">
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                  fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                  <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    fxFlexFill>
                    <form class="form-section payment-form-section">
                      <!-- ---------------------------- Payment Mode ----------------------------- -->
                      <ngx-stripe-card-group [formGroup]="stripeTest" [elementsOptions]="elementsOptions">
                        <div class="custom-form-group">
                          <label for="" class="custom-label">Card Number<span class="star">*</span></label>
                          <div class="custom-form-control">
                            <ngx-stripe-card-number (change)="numberChange($event)" [options]="cardOptions"></ngx-stripe-card-number>
                              <!-- Loader while verifying -->
                        <!-- Inline loader (right side of input) -->
                            <div *ngIf="isCardNumberVerifying" class="loader-inline">
                              <mat-spinner diameter="20"></mat-spinner>
                            </div>
                          <mat-error *ngIf="numberIsTouched && cardErrorMessage && !isCardNumberVerifying">
                              {{ cardErrorMessage }}
                            </mat-error>
                          </div>
                        </div>
                        <div class="custom-form-group">
                          <label for="" class="custom-label">Expiry Date<span class="star">*</span></label>
                          <div class="custom-form-control">
                            <ngx-stripe-card-expiry (change)="expiryChange($event)" [options]="cardOptions"></ngx-stripe-card-expiry>
                              <div *ngIf="isCardExpiryVerifying" class="loader-inline">
                                <mat-spinner diameter="20"></mat-spinner>
                              </div>

                              <mat-error *ngIf="expiryIsTouched && expiryErrorMessage && !isCardExpiryVerifying">
                                {{ expiryErrorMessage }}
                              </mat-error>
                          </div>
                        </div>
                        <div class="custom-form-group">
                          <label for="" class="custom-label">CVV<span class="star">*</span></label>
                          <div class="custom-form-control">
                            <ngx-stripe-card-cvc (change)="cvcChange($event)" [options]="cardOptions"></ngx-stripe-card-cvc>
                            
                           <div *ngIf="isCardCvcVerifying" class="loader-inline">
                              <mat-spinner diameter="20"></mat-spinner>
                            </div>

                            <mat-error *ngIf="cvcIsTouched && cvcErrorMessage && !isCardCvcVerifying ">
                              {{ cvcErrorMessage }}
                            </mat-error>
                          </div>
                        </div>
                      </ngx-stripe-card-group>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button class="modal-cancel-btn modal-footer-btn" *ngIf="userDetails.payment_completed"   (click)="close()">
              <span>Cancel</span>
            </button>
            <button type="submit" *ngIf="data.type == 'addcard'" mat-button class="modal-save-btn global-btn modal-footer-btn"
              (click)="completePayment()">
              <span>Pay</span>
            </button>
            <button type="submit" *ngIf="data.type == 'updatecard'" mat-button class="modal-save-btn global-btn modal-footer-btn"
              (click)="completePayment()">
              <span>Update Card</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  